export default __webpack_public_path__ + "static/media/753.abf106ea.png";